import { all, takeEvery, put, fork, call } from "redux-saga/effects";
import actions from "./actions";

export function* getBlogs() {
  yield takeEvery(actions.FETCH_BLOGS_REQUESTED, function* (action) {
    try {
      const blogs = yield call(actions.getBlogs, action.payload);
      yield put({ type: actions.FETCH_BLOGS_SUCCEEDED, blogs });
    } catch (error) {
      yield put({ type: actions.FETCH_BLOGS_FAILED, error: error.message });
    }
  });
}

export function* getBlog() {
  yield takeEvery(actions.FETCH_BLOG_REQUESTED, function* (action) {
    try {
      const blog = yield call(actions.getBlog, action.payload);
      yield put({
        type: actions.FETCH_BLOG_SUCCEEDED,
        blog: blog.blog_info,
      });
    } catch (error) {
      yield put({ type: actions.FETCH_BLOG_FAILED, error: error.message });
    }
  });
}

export function* deleteBlog() {
  yield takeEvery(actions.DELETE_BLOG_REQUESTED, function* (action) {
    try {
      const blog = yield call(actions.deleteBlog, action.payload);
      yield put({ type: actions.DELETE_BLOG_SUCCEEDED, blogDeleted: blog });
    } catch (error) {
      yield put({ type: actions.DELETE_BLOG_FAILED, error: error.message });
    }
  });
}

export default function* rootSaga() {
  yield all([fork(getBlogs), fork(getBlog), fork(deleteBlog)]);
}
